module.exports = __webpack_public_path__ + "media/images/dashboard_icons/chart4-41867c7546d08654ac967d3810e7b926.svg";